module.exports = __webpack_public_path__ + "img/Ventas.5db5baf2.png";